
<template>
  <div class="col-span-12">
    <div class="grid grid-cols-12 gap-4" v-if="isFiled">
      <div class="col-span-12 mx-auto mt-1 relative">
        <!-- Loading Overlay -->
        <div v-if="loading" class="absolute inset-0 bg-gray-50 bg-opacity-75 flex items-center justify-center rounded z-50">
          <div class="text-center">
            <i class="fa fa-spinner fa-spin fa-3x text-primary"></i>
            <p class="mt-2 text-sm text-gray-600">Loading...</p>
          </div>
        </div>

        <div class="col-span-12 mx-auto mt-1">
          <div class="grid grid-cols-12 gap-4 mx-1 py-1">
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"                  id="companyName"


                  disabled="true"
                  :value="getCompanyAddress?.data?.village?.country?.name || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"                  id="companyName"


                  disabled="true"
                  :value="getCompanyAddress?.data?.village?.region?.name || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"

                  disabled="true"
                  :value="getCompanyAddress?.data?.village?.district?.name?.toLowerCase() || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"

                  disabled="true"
                  :value="getCompanyAddress?.data?.village?.subcounty?.name || ''"
                  required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"                  id="companyName"


                  disabled="true"
                  :value="getCompanyAddress?.data?.village?.parish?.name || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"                 id="companyName"


                  disabled="true"
                  :value="getCompanyAddress?.data?.village?.village?.name || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input type="text" id="companyName"
                  disabled="true"
                  :value="getCompanyAddress?.data?.address?.plot || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input type="text"
                  disabled="true"
                  :value="getCompanyAddress?.data?.address?.street || ''"
                  required/>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input type="text" id="companyName"
                  disabled="true"
                  :value="getCompanyAddress?.data?.address?.postalAddress || ''"
                  required/>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <textarea
                  id="companyName"
                  class="form-text text-sm noFocus text-capitalize"
                  rows="4"
                  disabled="true"
                  :value="getCompanyAddress?.data?.address?.description || ''"
                  required>
                </textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-4" v-else>
      <div class="col-span-12 mt-3 text-sm" v-if="lockDown">
        <div class="bg-gray-100 border border-gray-300 rounded px-4 py-3 text-gray-700">
          <i class="fa fa-info-circle mr-2"></i> Form 18 is not yet Filed. Please click <a class="text-blue underline">here</a> to have it filed after your account is activated back
        </div>
      </div>
      <div class="col-span-12 mt-3 text-sm" v-else>
        <div class="bg-red-50 border border-red-300 rounded px-4 py-3 text-red-700">
          <i class="fa fa-info-circle mr-2"></i> Form 18 is not yet Filed. Please click <router-link class="text-blue underline" :to="{name:'file-resolutions'}">here</router-link> to have it filed
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import { useBusinessFileStore } from "@/stores/business-file";

const props = defineProps<{ isFiled: boolean; brn: string }>();

const fileStore = useBusinessFileStore();

const lockDown = ref(false);
const loading = ref(true);

const getCompanyAddress = computed(() => fileStore.address);

onMounted(() => {
  fileStore.fetchCompanyAddress(props.brn);
  fileStore.fetchFilingCompliance(props.brn);
});

watch(() => fileStore.address, () => {
  loading.value = false;
});

watch(() => fileStore.filing_compliance, (data) => {
  if (data?.data) {
    lockDown.value = false;
  }
});
</script>

